import * as React from 'react';
import type { SVGProps } from 'react';

const RocketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M66.125 31.625C66.125 34.8006 63.5506 37.375 60.375 37.375C57.1994 37.375 54.625 34.8006 54.625 31.625C54.625 28.4494 57.1994 25.875 60.375 25.875C63.5506 25.875 66.125 28.4494 66.125 31.625Z"
      fill="#FE5000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.875 77.625L57.5 92L0 34.5L14.375 20.125H37.375L44.0269 13.4731C52.6536 4.84642 64.3539 0 76.5538 0H92V15.4462C92 27.6461 87.1536 39.3464 78.5269 47.9731L71.875 54.625V77.625ZM63.25 51.0524L72.4281 41.8743C79.4373 34.8651 83.375 25.3586 83.375 15.4462V8.625H76.5538C66.6414 8.625 57.1349 12.5627 50.1257 19.5719L40.9476 28.75H17.9476L12.1976 34.5L57.5 79.8024L63.25 74.0524V51.0524Z"
      fill="#FE5000"
    />
    <path d="M24.1627 74.9258L30.7521 81.5152L5.75 92L0 86.25L10.4848 61.2479L17.0742 67.8373L11.9546 80.0454L24.1627 74.9258Z" fill="#FE5000" />
  </svg>
);

export default RocketIcon;
